import Model from './Model'

export default class User extends Model {

    schema() {
        return {
            id: null,
            name: null,
            email: null,
            role: null,
            permissions: [],
        }
    }

    can( permission )
    {
        let superadminPermissions = [
            'bulk remove images',
            'actions groupes remove_images',
            'cut stock',
        ];
        if (superadminPermissions.find( v => v == permission )) {
            return this.role.find(v => v == 'superadmin') || this.email === 'info@divioseo.fr';
        }

        return this.role.find(v => v == 'admin') || this.permissions.find( v => v == permission );
    }

}
